import axios from 'axios';

/** Specification of the response from the auth token endpoint */

/**
 * Internal variable that contains a cache to the last request performed to
 * retrive an authorization token for the mediaplayer. This allows us to
 * prevent concurrent requests to fetch tokens as well as caching already
 * fetched tokens for a given period of time.
 */
let tokenPromise;

/**
 * Internal variable containing the timestamp of when we last requested an
 * authorization token from the remote backend.
 */
let tokenLastRequestedAt;

/**
 * Helper that gets an auth token that can be used to allow playback of the
 * mediafile from Gyldendal's MediaServer. We cache these tokens for up to
 * 30 minutes at a time, in order to avoid fetching multiple identical
 * tokens.
 */
async function getMediaplayerToken() {
  // If a token has already been requested within the last 30 minutes, then
  // return the existing promise "as is"
  if (!tokenPromise || tokenLastRequestedAt < Date.now() - 1800000) {
    tokenPromise = axios.get(`${process.env["NEXT_PUBLIC__MEDIA_LIBRARY_API"]}/api/token`);
    tokenLastRequestedAt = Date.now();
  }

  // Wait for the response to become available
  const response = await tokenPromise;

  // Return the token
  return response.data.access_token;
}

export { getMediaplayerToken };
//# sourceMappingURL=api.get-media-player-token.js.map
